"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllegroTransformGraphicsGenerator = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const hash_1 = require("@cadstrom/sigma-engine-shared/dist/Utils/hash");
const TransformSchematic_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformSchematic");
const TransformSchematicDrawing_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformSchematicDrawing");
const TransformImageExtraction_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformImageExtraction");
const allegroLayers_1 = require("../../../allegroLayers");
class AllegroTransformGraphicsGenerator {
    constructor() {
        this.runsFor = [
            TransformSchematic_1.TransformSchematic,
        ];
    }
    *generate(schematic, rootContext) {
        const pageNum = schematic.instance.hierarchyEntry.loaded.pageNum;
        const design = rootContext.resolved.designs.find((d) => d.pageNum === pageNum);
        if (design === undefined) {
            return;
        }
        yield* emitRichTexts(schematic, design);
        yield* emitImages(schematic, design, rootContext);
        yield* emitDashedRects(schematic, design);
    }
}
exports.AllegroTransformGraphicsGenerator = AllegroTransformGraphicsGenerator;
function* emitRichTexts(schematic, design) {
    for (const richText of design.richTexts) {
        const drawing = {
            layers: [allegroLayers_1.AllegroSchLayerMap[sigma_engine_shared_1.DesignModels.SchLayerType.Other].id],
            drawing: buildRichTextDrawing(richText),
        };
        yield new TransformSchematicDrawing_1.TransformSchematicDrawing(schematic, drawing);
    }
}
function buildRichTextDrawing(richText) {
    return {
        type: 'rich-text',
        pos: richText.pos,
        width: richText.width,
        height: richText.height,
        paragraphs: richText.paragraphs,
        ...(richText.defaultSizePt !== undefined ? { defaultSizePt: richText.defaultSizePt } : {}),
        ...(richText.defaultBold !== undefined ? { defaultBold: richText.defaultBold } : {}),
        ...(richText.defaultItalic !== undefined ? { defaultItalic: richText.defaultItalic } : {}),
        ...(richText.defaultFont !== undefined ? { defaultFont: richText.defaultFont } : {}),
    };
}
function* emitDashedRects(schematic, design) {
    for (const rect of design.dashedRects) {
        const drawing = {
            layers: [allegroLayers_1.AllegroSchLayerMap[sigma_engine_shared_1.DesignModels.SchLayerType.Other].id],
            drawing: buildDashedRect(rect),
        };
        yield new TransformSchematicDrawing_1.TransformSchematicDrawing(schematic, drawing);
    }
}
const DASHED_RECT_STROKE_WIDTH_MM = 0.2;
function buildDashedRect(rect) {
    return {
        type: 'rect',
        start: rect.pos,
        end: [rect.pos[0] + rect.width, rect.pos[1] + rect.height],
        strokeWidth: DASHED_RECT_STROKE_WIDTH_MM,
        lineStyle: 'dash',
    };
}
function* emitImages(schematic, design, rootContext) {
    for (const image of design.images) {
        const bytes = rootContext.resolveImageBytes(image.filename);
        if (bytes === null) {
            continue;
        }
        const mime = detectImageMimeType(bytes);
        if (mime === null) {
            continue;
        }
        const ref = `images/${(0, hash_1.fnv1aHash)(image.filename)}.${mime.ext}`;
        const drawing = {
            layers: [allegroLayers_1.AllegroSchLayerMap[sigma_engine_shared_1.DesignModels.SchLayerType.Image].id],
            drawing: buildImageDrawing(image, ref),
        };
        yield new TransformSchematicDrawing_1.TransformSchematicDrawing(schematic, drawing);
        yield new TransformImageExtraction_1.TransformImageExtraction(schematic, ref, image.filename, bytes, mime.mimeType);
    }
}
function buildImageDrawing(image, ref) {
    const drawing = {
        type: 'image',
        pos: image.pos,
        width: image.width,
        height: image.height,
        imageRef: ref,
    };
    if (image.angle !== 0) {
        drawing.angle = image.angle;
    }
    return drawing;
}
function detectImageMimeType(data) {
    if (data.length < 4) {
        return null;
    }
    const isPng = data[0] === 0x89 && data[1] === 0x50 && data[2] === 0x4e && data[3] === 0x47;
    if (isPng) {
        return { mimeType: 'image/png', ext: 'png' };
    }
    const isJpeg = data[0] === 0xff && data[1] === 0xd8;
    if (isJpeg) {
        return { mimeType: 'image/jpeg', ext: 'jpg' };
    }
    const isBmp = data[0] === 0x42 && data[1] === 0x4d;
    if (isBmp) {
        return { mimeType: 'image/bmp', ext: 'bmp' };
    }
    return { mimeType: 'application/octet-stream', ext: 'bin' };
}
//# sourceMappingURL=AllegroTransformGraphicsGenerator.js.map